export const formattedBalance = (balance: string) => {
    if (balance === '0') {
        return ['0', '']
    }
    if (Math.abs(Number(balance)) < 100) {
        return ['0', balance.padStart(2, '0')]
    }

    const integerPart = balance.slice(0, -2)
    const decimalPart = balance.slice(-2)
    const formattedIntegerPart = integerPart.replaceAll(/\B(?=(\d{3})+(?!\d))/g, ' ')

    return [formattedIntegerPart, decimalPart]
}

export const formatMinutesToHours = (duration: number) => {
    const hours = Math.floor(duration / 60)
    const minutes = duration % 60

    return `${hours} ч ${minutes} м`
}

export const formatDateToIso = (date: string): string => {
    const match = date.match(/^(\d{2})\.(\d{2})\.(\d{4})$/)

    if (!match) {
        throw new Error('Invalid date format')
    }
    const [, day, month, year] = match

    return `${year}-${month}-${day}`
}

export const formatPhone = (phone: string) => {
    const digits = phone.replaceAll(/\D/g, '')
    const match = digits.match(/^(\d)(\d{3})(\d{3})(\d{2})(\d{2})$/)

    if (!match) {
        return phone
    }

    const [, country, operator, first, second, third] = match

    return `+${country} ${operator} ${first}-${second}-${third}`
}
